import { React, useState } from "react";
import { isMobile, isDesktop } from "react-device-detect";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { SVGIcons, ImgIcons, Imgbanner, getcolors } from "../../Helpers/Common";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";
import Hover from "../OnHoverDetails/Hover";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Navigation } from "swiper";

var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));

export function Layout2(props) {
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(data);
  }

  let Closepopup = () => {
    setshowdetails(false);
  };

  var settings = {
    slidesToShow: 1,
    centerMode: true,
    arrows: false,
    variableWidth: true,
    dots: false,
    swipeToSlide: true,
    speed: 700,
    infinite: true,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
          // centerPadding: '20px',
        },
      },
    ],
  };

  const headerText = () => {
    return (
      <div className="head">
        <h3>
          {props.title.display_title}
          <span className="red">{props.title.display_title_sufix}</span>
        </h3>
      </div>
    );
  };

  return (
    <>
      <section className="mb-0 dD-none">
        <div className="temp27">
          {headerText()}
          <div className="temp27-area">
            <div className="temp27-slider">
              <Slider {...settings}>
                {props.Layout1.map((data, index) => {
                  var bgcolors = getcolors;
                  var random = Math.floor(Math.random() * bgcolors.length);

                  if (data.content_bg_color) {
                    var bgcolor = { backgroundColor: bgcolors[random] };
                  } else {
                    var bgcolor = { backgroundColor: bgcolors[random] };
                  }

                  var keyword = data.keywords.split(",")[0];

                  var premium = "";
                  if (data.premium && !data.original_tag) {
                    var premium = (
                      <img
                        src={props.silverIcon}
                        style={{
                          width: "1.7rem",
                          "margin-right": "3px",
                          "margin-bottom": "2px",
                        }}
                      />
                    );
                  }
                  if (data.original_tag && data.premium) {
                    var original = (
                      <img
                        src={props.goldenIcon}
                        style={{
                          width: "1.7rem",
                          "margin-right": "3px",
                          "margin-bottom": "2px",
                        }}
                      />
                    );
                  }
                  return (
                    <div className="temp27-sliderItem" key={data.ID}>
                      <div
                        onClick={() => {
                          showdetailspop(data);
                        }}
                      >
                        <div className="temp27-item">
                          <div
                            className="temp27-itemColor"
                            style={{
                              backgroundImage: `url(${data.thumbnail_image2.medium})`,
                            }}
                          >
                            <img
                              src={data.thumbnail_image2.medium}
                              alt="DocuBay"
                            />
                          </div>
                          <div className="bay-title">{keyword}</div>
                          <div className="premium-red">
                            {premium}
                            {original}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        </div>
      </section>
      <section className="mb-0 dD-block">
        <div className="temp23">
          <div className="head1">
            <h3>
              {props.title.display_title}
              <span className="red">{props.title.display_title_sufix}</span>
            </h3>
          </div>
          <div className="temp23-area">
            <Swiper
              navigation={{
                prevEl: ".slick-prev",
                nextEl: ".slick-next",
              }}
              slidesPerView={2.4}
              spaceBetween={16}
              slidesPerGroup={6}
              freeMode={true}
              loop={false}
              loopFillGroupWithBlank={true}
              centeredSlides={false}
              breakpoints={{
                650: {
                  slidesPerView: 1,
                },
                850: {
                  slidesPerView: 6.3,
                },
              }}
              modules={[Navigation, FreeMode, Pagination]}
              className="temp23-slider"
            >
              <div className="side-overlay-L dD-block"></div>
              <button
                className="slick-prev slick-arrow"
                type="button"
                aria-label="Previous"
              />
              {props.Layout1.map((data, index) => {
                var bgcolors = getcolors;
                var random = Math.floor(Math.random() * bgcolors.length);

                if (data.content_bg_color) {
                  var bgcolor = { backgroundColor: bgcolors[random] };
                } else {
                  var bgcolor = { backgroundColor: bgcolors[random] };
                }

                var keyword = data.keywords.split(",")[0];

                var premium = "";
                if (data.premium && !data.original_tag) {
                  var premium = (
                    <img
                      src={props.silverIcon}
                      style={{
                        width: "1.7rem",
                        "margin-right": "3px",
                        "margin-bottom": "2px",
                      }}
                    />
                  );
                }
                if (data.original_tag && data.premium) {
                  var original = (
                    <img
                      src={props.goldenIcon}
                      style={{
                        width: "1.7rem",
                        "margin-right": "3px",
                        "margin-bottom": "2px",
                      }}
                    />
                  );
                }
                return (
                  <SwiperSlide key={index} className="temp23-item">
                    <Hover
                      data={data}
                      silverIcon={props.silverIcon}
                      goldenIcon={props.goldenIcon}
                    />
                    <div className="temp23-itemColor" style={bgcolor}>
                      <img src={data.thumbnail_image2.medium} alt="DocuBay" />
                    </div>
                    <div className="bay-title">{keyword}</div>
                    <div className="premium-red">
                      {premium}
                      {original}
                    </div>
                  </SwiperSlide>
                );
              })}
              <SwiperSlide></SwiperSlide>
              <div className="side-overlay-R dD-block"></div>
              <button
                className="slick-next slick-arrow"
                type="button"
                aria-label="Next"
              />
            </Swiper>
          </div>
        </div>
      </section>
      {showdetails ? (
        <Showdetailspopup
          data={details}
          Closebtn={Closepopup}
          silverIcon={props.silverIcon}
          goldenIcon={props.goldenIcon}
        />
      ) : null}
    </>
  );
}

export default Layout2;
